import { FLOW_MODE } from "../../constants";
import { LivenessCheckProcessor } from "./LivenessCheckProcessor";
import { EnrollmentProcessor } from "./EnrollmentProcessor";
import { Authenticate3DProcessor } from "./Authenticate3DProcessor";
export var createFlowProcessor = function (sessionToken, sampleAppControllerReference, mode, enrollmentId) {
    if (mode === FLOW_MODE.ENROLLMENT) {
        return new EnrollmentProcessor(sessionToken, sampleAppControllerReference, enrollmentId);
    }
    if (mode === FLOW_MODE.AUTH_3D) {
        return new Authenticate3DProcessor(sessionToken, sampleAppControllerReference, enrollmentId);
    }
    return new LivenessCheckProcessor(sessionToken, sampleAppControllerReference);
};
